import { Component } from '@angular/core';

@Component({
  selector: 'atelier-sign',
  templateUrl: './atelier-sign.component.html',
  styleUrls: ['./atelier-sign.component.scss']
})
export class AtelierSignComponent {}
